import { map } from 'nanostores';
import * as api from '../services/api.js';

export const $scheduled = map({});

export async function loadScheduled(chatId, channelId) {
  if (!chatId) return;
  const key = channelId ? `${chatId}:${channelId}` : chatId;
  try {
    const rows = await api.getScheduledMessages(chatId, channelId);
    const list = Array.isArray(rows) ? rows : (Array.isArray(rows?.data) ? rows.data : []);
    $scheduled.setKey(key, list);
  } catch (e) {
    console.warn('[scheduled] load failed:', e.message);
  }
}

// T7 — first arg is the composite chatKey (phone:channelId) produced
// by Thread.js, NOT the raw chat_id. Naming this `key` now to match
// reality; all three helpers take the same store key.
export function addScheduled(key, msg) {
  const current = $scheduled.get()[key] || [];
  $scheduled.setKey(key, [...current, msg]);
}

export function removeScheduled(key, msgId) {
  const current = $scheduled.get()[key] || [];
  $scheduled.setKey(key, current.filter(m => m.id !== msgId));
}

export function clearScheduled(key) {
  $scheduled.setKey(key, []);
}

/**
 * S23 — scan every $scheduled bucket for any row whose id matches the
 * given scheduledId, and drop it. Called from the realtime handler when
 * an outbound message lands with correlation_id = scheduled.id (the cron
 * now uses the scheduled row UUID as the correlation_id). Keeps the
 * ghost bubble from lingering in the thread after the real bubble
 * arrives.
 *
 * Iterates all $scheduled keys because the realtime message_insert
 * doesn't always carry the same composite (phone, channel) shape as
 * the store key — scanning is O(n_chats_with_scheduled) which is
 * cheap at any realistic scale (dozens, not thousands).
 */
export function removeScheduledById(scheduledId) {
  if (!scheduledId) return;
  const all = $scheduled.get();
  for (const key in all) {
    const list = all[key];
    if (!Array.isArray(list) || !list.length) continue;
    const next = list.filter(m => m?.id !== scheduledId);
    if (next.length !== list.length) $scheduled.setKey(key, next);
  }
}

/**
 * T2 — patch a scheduled row in-place so the UI can flip to its Failed
 * (or Sending-now) state. The server never sends us the row again after
 * it transitions out of 'pending' — GET /scheduled filters to pending
 * only — so we stamp the transient UI state locally from the broadcast
 * payload.
 *
 * Returns true when a row was actually patched, false when the row
 * wasn't found in any bucket (which means we weren't tracking it —
 * likely the thread was closed, nothing to do).
 */
export function patchScheduledById(scheduledId, patch) {
  if (!scheduledId) return false;
  const all = $scheduled.get();
  let touched = false;
  for (const key in all) {
    const list = all[key];
    if (!Array.isArray(list) || !list.length) continue;
    let hit = false;
    const next = list.map(m => {
      if (m?.id === scheduledId) { hit = true; return { ...m, ...patch }; }
      return m;
    });
    if (hit) {
      $scheduled.setKey(key, next);
      touched = true;
    }
  }
  return touched;
}
